module.exports = __webpack_public_path__ + "img/criterion-cat.cdfa8824.png";